import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { OBJLoader } from "three/addons/loaders/OBJLoader.js";
import { STLLoader } from "three/addons/loaders/STLLoader.js";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Nav from "./controls/Nav";
import Stepper from "./stepper/Stepper";
import Loader from "./Loader";
import {
  apiResolver,
  getJSON,
  getTSUrlsForEonMfg,
} from "@/helpers/apiResolver";
import { getParams } from "@/helpers/getParams";
import "./viewer.scss";
import { ThreeJsViews } from "./ThreeJsViews";
import ViewerNotFound from "./ViewerNotFound";
import { useQuery } from "@tanstack/react-query";
import { StagingTimeLine } from "./overlays/StagingTimeLine";
import {
  BoltonAnalysis,
  convertBoltonToNumeric,
} from "./overlays/BoltonAnalysis";
import { MovementTable } from "./overlays/MovementTable";
import { OverlayWrapper } from "./overlays/OverlayWrapper";
import { isEmpty } from "@/helpers/functions";
import TeethControls from "./teethControls/TeethControls";
import { useGlobalStore } from "../../store";
import { mapStagingTimeline } from "@/helpers/mapStagingTimeline";
import { useWindowOrientation } from "@/hooks/useWindowOrientation";
import { OverbiteAnalysis } from "./overlays/OverbiteAnalysis";
import DoctorModifications from "./modifications";

//added by hamzeh
import { numberingUniversal } from "@/helpers/teethNumbering";
import poppins from "@/static/poppins_regular.json";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
import ApproveTPModal from "../demo-tp/ApproveTPModal";
import Header from "./Header";
import { themeConfig } from "@/helpers/themeConfigrasions";

import { demoMovementTable } from "../demo-tp/demoMovementTable";
import { demoBoltonAnalysisInfo } from "../demo-tp/demoBoltonAnalysisInfo";
import {
  SetCutsAndButtonsElasticsData,
  TDMSTeethNumbersToUniversal,
  TurnElastics,
} from "./Elastics";
import { Saving, ChangeSaved } from "../shared-components/AutoSave";
import RevisedTreatment from "./modifications/RevisedTreatment";
import Records from "./overlays/Records";
import { Approve } from "./Approve";
import { Reject } from "./Reject";
import {
  endLoadingTime,
  setSuperProps,
  StartLoadingTime,
  startSession,
} from "@/mixpanel/Mixpanel";
import { useCustomTranslation } from "@/hooks/useTranslation";
import {
  ponticsData,
  preparePonticsData,
  turnPontics,
} from "./controls/Pontics";
import GhostCursorComponent from "@/helpers/GhostCursorComponent";
import { getSingedURL } from "@/helpers/getSingedURL";
import AttachmentsToaster from "./teethControls/AttachmentsToaster";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { toggleIPRs } from "@/helpers/ipr";
import {
  disposeObject,
  isAdvancedHeatmaps,
  measurementTool,
  setIsAdvancedHeatmaps,
  setIsOrbitControlsAuthorized,
} from "./Mesh";
import { IdleManager } from "./IdleState";
import { isAppleMobile, isMobileBrowser } from "@/helpers/detectBrowser";
import { SingletonManager } from "../../helpers/singletonInitializer.ts";
import {
  assignBaseTeethGLB1,
  assignBaseAtt,
  startMeshOrganisingLocally as startBaseMeshOrganising,
} from "./localTSReader.js";
import {
  globalData,
  isGlobalStoreToggleDefined,
  setGlobalStoreToggleRef,
  setToggle,
} from "../../helpers/globData.ts";
import { setBJMatrices, setIsBiteJumpActive } from "./Bitejump.ts";
import { Jaw } from "./interfaces.ts";
import { UnzipHelper } from "./unzipHelper.js";
import { getDisplayOption } from "../../helpers/getRootsOptions.js";
import { createBone, createRoot, RB } from "./rootsAndBonesManager.js";
// end
const GLBData = [];
export let GLBDataV2;
export let isBJ;
export let globalBiteJump;
export let globalMaxStepNumber = 0;
export let idleManager;
let loadingCounter = 0; // tp loaded when value is 2
let newMethod = false;

let teethTransformationData;
export let myOTP;
export const teethMovementData = [];

export const teethMovementDataPerStep = [];

let loadedOnce = false;
let globalDiff = 0; // if negative l > u : u > l```
let fakeAttachmentReplacer;
const textMaterial = SingletonManager.materialManager.createMaterial(
  "MeshPhongMaterial",
  { color: "black" },
);

// new THREE.MeshPhongMaterial({ color: "black" });

let once = false;

function isNegative(num) {
  return Math.sign(num) === -1;
}
let bad = false;
//caching
let c1, c2;
function TeethSort(a, b) {
  c1 = parseInt(a.name.split("_")[2].substring(1, 5));
  c2 = parseInt(b.name.split("_")[2].substring(1, 5));
  if (c1 < c2) {
    return -1;
  } else if (c1 > c2) {
    return 1;
  }
  return 0;
}
function MeshOrganiser(model) {
  const steps2 = model;
  let upper = { gum: {}, teeth: [] };
  let lower = { gum: {}, teeth: [] };
  let longerPart;
  let longer;
  if (!model.children[2].userData.start_together) {
    if (model.children[0].children.length > model.children[1].children.length) {
      let diff =
        model.children[0].children.length - model.children[1].children.length;
      globalDiff = diff;
      for (let i = 0; i < diff; i++) {
        steps2.children[1].children.unshift(steps2.children[1].children[0]);
      }
    } else if (
      model.children[0].children.length < model.children[1].children.length
    ) {
      let diff =
        model.children[1].children.length - model.children[0].children.length;
      globalDiff = -diff;
      for (let i = 0; i < diff; i++) {
        steps2.children[0].children.unshift(steps2.children[0].children[0]);
      }
    }
  }
  if (steps2.children[0].children.length > steps2.children[1].children.length) {
    longer = steps2.children[0].children.length;
    longerPart = steps2.children[0];
  } else {
    longer = steps2.children[1].children.length;
    if (globalDiff <= 0) {
      longerPart = steps2.children[1];
    } else {
      longerPart = steps2.children[0];
    }
  }
  //
  let isOneArch = false;
  if (
    steps2.children[0].children.length <= 1 ||
    steps2.children[1].children.length <= 1
  ) {
    console.log("this is one arch");
    isOneArch = true;
  }
  if (isOneArch) {
    // old end together solution
    for (let stepNumber = 0; stepNumber < longer; stepNumber++) {
      for (let i = 0; i < longer; i++) {
        // steps
        if (longerPart.children[i].name.includes("st".concat(stepNumber))) {
          if (steps2.children[0].children.length > i) {
            //24 , 25
            upper = { gum: {}, teeth: [] };
            steps2.children[0].children[i].children.map(child => {
              if (child.name.includes("gum")) {
                upper.gum = child;
              } else {
                const ref1 = new THREE.Mesh(child.geometry, child.material);
                ref1.name = child.name;
                const attachmentGroup = new THREE.Group(),
                  numberingGroup = new THREE.Group(),
                  iprGroup = new THREE.Group(),
                  rootAnchorsGroup = new THREE.Group(),
                  elasticsGroup = new THREE.Group();
                attachmentGroup.name = "attachments";
                numberingGroup.name = "numbering";
                iprGroup.name = "IPRs";
                rootAnchorsGroup.name = "rootAnchorsGroup";
                elasticsGroup.name = "elasticsGroup";

                for (let x = 0; x < child.children.length; x++) {
                  attachmentGroup.add(
                    new THREE.Mesh(
                      child.children[x].geometry,
                      child.children[x].material,
                    ),
                  );
                }

                ref1.add(attachmentGroup);
                numberingGroup.visible = false;
                ref1.add(numberingGroup);
                ref1.add(iprGroup);
                ref1.add(rootAnchorsGroup);
                ref1.add(elasticsGroup);

                fillWithDefaultColor(ref1);
                upper.teeth.push(ref1);
              }
            });
          }
          if (steps2.children[1].children.length > i) {
            // 62
            lower = { gum: {}, teeth: [] };
            steps2.children[1].children[i].children.map(child => {
              if (child.name.includes("gum")) {
                lower.gum = child;
              } else {
                const ref1 = new THREE.Mesh(child.geometry, child.material);
                ref1.name = child.name;
                const attachmentGroup = new THREE.Group(),
                  numberingGroup = new THREE.Group(),
                  iprGroup = new THREE.Group(),
                  rootAnchorsGroup = new THREE.Group(),
                  elasticsGroup = new THREE.Group();

                attachmentGroup.name = "attachments";
                numberingGroup.name = "numbering";
                iprGroup.name = "IPRs";
                rootAnchorsGroup.name = "rootAnchorsGroup";
                elasticsGroup.name = "elasticsGroup";

                for (let x = 0; x < child.children.length; x++) {
                  attachmentGroup.add(
                    new THREE.Mesh(
                      child.children[x].geometry,
                      child.children[x].material,
                    ),
                  );
                }

                ref1.add(attachmentGroup);
                numberingGroup.visible = false;
                ref1.add(numberingGroup);
                ref1.add(iprGroup);
                ref1.add(rootAnchorsGroup);
                ref1.add(elasticsGroup);

                fillWithDefaultColor(ref1);
                lower.teeth.push(ref1);
              }
            });
          }
          lower.teeth.sort(TeethSort);
          upper.teeth.sort(TeethSort);
          GLBData[stepNumber] = { upper, lower };
          break;
        }
      }
    }
  } // new end together solution
  else {
    //start together + end together + equal steps + one scan
    for (let stepNumber = 0; stepNumber < longer; stepNumber++) {
      let r = stepNumber;
      if (steps2.children[0].children.length <= stepNumber + (isBJ ? 1 : 0)) {
        r =
          steps2.children[0].children.length -
          1 -
          (isBJ && stepNumber + 1 < longer ? 1 : 0);
      }
      upper = { gum: {}, teeth: [] };
      if (r >= 0) {
        steps2.children[0].children[r].children.map(child => {
          if (child.name.includes("gum")) {
            upper.gum = new THREE.Mesh(child.geometry, child.material);
            upper.gum.name = "u_st" + stepNumber + "_gum";
          } else {
            // const simplified = i === 66 ? TestSimplifier(child, 95) : child;
            const ref1 = new THREE.Mesh(child.geometry.clone(), child.material);
            ref1.name =
              "u_st" +
              stepNumber +
              "_t" +
              child.name.split("_")[2].substring(1, 4);
            const attachmentGroup = new THREE.Group(),
              numberingGroup = new THREE.Group(),
              iprGroup = new THREE.Group(),
              rootAnchorsGroup = new THREE.Group(),
              elasticsGroup = new THREE.Group();

            attachmentGroup.name = "attachments";
            numberingGroup.name = "numbering";
            iprGroup.name = "IPRs";
            rootAnchorsGroup.name = "rootAnchorsGroup";
            elasticsGroup.name = "elasticsGroup";

            for (let x = 0; x < child.children.length; x++) {
              attachmentGroup.add(
                new THREE.Mesh(
                  child.children[x].geometry,
                  child.children[x].material,
                ),
              );
            }

            ref1.add(attachmentGroup);
            numberingGroup.visible = false;
            ref1.add(numberingGroup);
            ref1.add(iprGroup);
            ref1.add(rootAnchorsGroup);
            ref1.add(elasticsGroup);

            fillWithDefaultColor(ref1);
            upper.teeth.push(ref1);
          }
        });
      }
      r = stepNumber;
      if (steps2.children[1].children.length <= stepNumber + (isBJ ? 1 : 0)) {
        r =
          steps2.children[1].children.length -
          1 -
          (isBJ && stepNumber + 1 < longer ? 1 : 0);
      }
      lower = { gum: {}, teeth: [] };
      if (r >= 0) {
        steps2.children[1].children[r].children.map(child => {
          if (child.name.includes("gum")) {
            lower.gum = new THREE.Mesh(child.geometry, child.material);
            lower.gum.name = "l_st" + stepNumber + "_gum";
          } else {
            const ref1 = new THREE.Mesh(child.geometry.clone(), child.material);
            ref1.name =
              "l_st" +
              stepNumber +
              "_t" +
              child.name.split("_")[2].substring(1, 4);
            const attachmentGroup = new THREE.Group(),
              numberingGroup = new THREE.Group(),
              iprGroup = new THREE.Group(),
              rootAnchorsGroup = new THREE.Group(),
              elasticsGroup = new THREE.Group();

            attachmentGroup.name = "attachments";
            numberingGroup.name = "numbering";
            iprGroup.name = "IPRs";
            rootAnchorsGroup.name = "rootAnchorsGroup";
            elasticsGroup.name = "elasticsGroup";
            for (let x = 0; x < child.children.length; x++) {
              attachmentGroup.add(
                new THREE.Mesh(
                  child.children[x].geometry,
                  child.children[x].material,
                ),
              );
            }

            ref1.add(attachmentGroup);
            numberingGroup.visible = false;
            ref1.add(numberingGroup);
            ref1.add(iprGroup);
            ref1.add(rootAnchorsGroup);
            ref1.add(elasticsGroup);

            fillWithDefaultColor(ref1);
            lower.teeth.push(ref1);
          }
        });
        lower.teeth.sort(TeethSort);
        upper.teeth.sort(TeethSort);
        GLBData[stepNumber] = { upper, lower };
      }
    }
  }
  // attachmentMaterial.opacity = options.numbering ? 0.5 : 1;
}

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {Number} val The initial value
 * @param {Number} min The lower boundary
 * @param {Number} max The upper boundary
 * @returns {Number} A number in the range (min, max)
 */
const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

function meshOrganiserFiller(model, otp) {
  const maxStepNumber = globalData.maxStepNumber;

  for (
    let step = 0, upperStep = 0, lowerStep = 0;
    step <= maxStepNumber;
    step++,
      upperStep = clamp(upperStep + 1, 0, globalData.upperSteps),
      lowerStep = clamp(lowerStep + 1, 0, globalData.lowerSteps)
  ) {
    const teethArr = otp.Stages[step].Teeth;

    let upper = {
      gum: model.children[0].children[upperStep].children[0]?.clone(),
      teeth: [...model.children[0].children[upperStep].children?.slice(1)],
    };

    let lower = {
      gum:
        model.children[1].children[lowerStep].children[0]?.clone() ||
        new THREE.Group(),
      teeth: [...model.children[1].children[lowerStep]?.children?.slice(1)],
    };

    upper.teeth.forEach(tooth => {
      preparePonticsTooth(
        tooth,
        "u",
        step,
        parseInt(tooth.name.split("_")[2].substring(1, 4)),
      );
    });

    lower.teeth.forEach(tooth => {
      preparePonticsTooth(
        tooth,
        "l",
        step,
        parseInt(tooth.name.split("_")[2].substring(1, 4)),
      );
    });
    for (let toothIndex = 0; toothIndex < teethArr.length; toothIndex++) {
      const toothOTPData = teethArr[toothIndex];

      if (toothOTPData.$type === "ExtractedTooth") {
        continue;
      } else {
        const tooth = new THREE.Mesh();
        const isLower = toothOTPData.Unn > 16;
        const jaw = isLower ? "l" : "u";
        tooth.name = `${jaw}_st${step}_t${toothOTPData.Unn}`;
        const attachmentGroup = new THREE.Group(),
          numberingGroup = new THREE.Group(),
          iprGroup = new THREE.Group(),
          rootAnchorsGroup = new THREE.Group(),
          elasticsGroup = new THREE.Group();
        attachmentGroup.name = "attachments";
        numberingGroup.name = "numbering";
        iprGroup.name = "IPRs";
        rootAnchorsGroup.name = "rootAnchorsGroup";
        elasticsGroup.name = "elasticsGroup";

        numberingGroup.visible = false;

        tooth.add(attachmentGroup);
        tooth.add(numberingGroup);
        tooth.add(iprGroup);
        tooth.add(rootAnchorsGroup);
        tooth.add(elasticsGroup);

        if (isLower) {
          lower.teeth.push(tooth);
        } else {
          upper.teeth.push(tooth);
        }
      }
    }
    lower.teeth.sort(TeethSort);
    upper.teeth.sort(TeethSort);

    GLBData.push({ upper, lower });
  }

  return GLBData;
}
function preparePonticsTooth(tooth, jaw, step, number) {
  tooth.removeFromParent();
  tooth.name = `${jaw}_st${step}_t${number}_pontics`;
  if (!step) {
    console.log(tooth.name);
  }
  tooth.userData["pontic"] = true;
  tooth.userData["number"] = number;
  tooth.userData["step"] = step;
  tooth.userData["jaw"] = jaw === "l" ? Jaw.Lower : Jaw.Upper;
  tooth.layers.set(0);

  prepareToothGroups(tooth);
}

function prepareToothGroups(tooth) {
  const attachmentGroup = new THREE.Group(),
    numberingGroup = new THREE.Group(),
    iprGroup = new THREE.Group(),
    rootAnchorsGroup = new THREE.Group(),
    elasticsGroup = new THREE.Group();
  attachmentGroup.name = "attachments";
  numberingGroup.name = "numbering";
  iprGroup.name = "IPRs";
  rootAnchorsGroup.name = "rootAnchorsGroup";
  elasticsGroup.name = "elasticsGroup";

  numberingGroup.visible = false;

  tooth.add(attachmentGroup);
  tooth.add(numberingGroup);
  tooth.add(iprGroup);
  tooth.add(rootAnchorsGroup);
  tooth.add(elasticsGroup);
}
export function fillWithDefaultColor(object) {
  // console.log(object.name);
  if (isMobileBrowser() || isAppleMobile()) {
    return;
  }

  object.geometry.setAttribute(
    "color",
    new THREE.BufferAttribute(
      new Float32Array(object.geometry.attributes.position.array.length).fill(
        1.0,
      ),
      3,
    ),
  );
}
function Scene() {
  const tdms = getParams().tdms === "true" ? true : false;
  const isPatient = getParams().isPatient === "true" ? true : false;
  const isC = getParams().isC === "true" ? true : false;

  const { isLoading, error, data } = useQuery({
    queryKey: ["treatmentSetupInfo"],
    queryFn: apiResolver,
    staleTime: 600000, // Cache data for 60 seconds (1 minute)
  });
  const displayMode = getDisplayOption(data);

  async function fetchData() {
    try {
      const result = await getTSUrlsForEonMfg();
      setResponse(result);
    } catch (error) {
      console.error("Error:", error);
    }
  }
  // async function fetchIssueType() {
  //   try {
  //     const result = await getIssueTypes();

  //     const convertedObject = result.reduce((acc, item) => {
  //       acc[item.value] = item.title;
  //       return acc;
  //     }, {});

  //     setIssueType(convertedObject);
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // }

  const isViewerControlsEnabled = data?.isViewerControlsEnabled;
  const localStorageSpace = function () {
    let allStrings = "";
    for (let key in window.localStorage) {
      if (window.localStorage.hasOwnProperty(key)) {
        allStrings += window.localStorage[key];
      }
    }
    return allStrings
      ? 3 + (allStrings.length * 16) / (8 * 1024) + " KB"
      : "Empty (0 KB)";
  };
  function parseTable(tableHtml) {
    const tableObject = [];

    const tableRows = tableHtml.querySelectorAll("tr");

    // Check if the first row contains the 'Tooth number' header
    const firstRow = tableRows[0];
    let headers = Array.from(firstRow.querySelectorAll("td")).map(td =>
      td.textContent.trim(),
    );
    if (!headers.includes("Tooth number")) {
      console.log("Table doesn't contain 'Tooth number'. Skipping...");
      return tableObject; // Return empty object
    }

    // Get column headers
    headers = headers.filter(header => header !== ""); // Remove empty headers if any
    // Iterate over rows (skip first row as it contains headers)
    for (let i = 1; i < tableRows.length; i++) {
      const rowData = {};
      const rowCells = tableRows[i].querySelectorAll("td");

      // Iterate over cells in row
      for (let j = 0; j < rowCells.length; j++) {
        rowData[headers[j]] = rowCells[j].textContent.trim();
      }

      // Push row data to table object
      tableObject.push(rowData);
    }
    return tableObject;
  }
  function fetchHTML() {
    // Fetch HTML content from the URL
    fetch(
      data?.movementTableUrl ? data?.movementTableUrl : "/DemoOrthoReport.html",
    )
      .then(response => response.text())
      .then(html => {
        // Parse the HTML string into a DOM object
        const parsedTables = [undefined];
        const domParser = new DOMParser();
        const doc = domParser.parseFromString(html, "text/html");
        // Get the table from the DOM object
        const tables = doc.querySelectorAll("table.OrthoAutoTable");
        // Parse the table into a JavaScript object
        tables.forEach(table => {
          if (parseTable(table).length) parsedTables.push(parseTable(table));
        });
        setParsedMovementTables(parsedTables);
        // console.log(parsedTables);
      })
      .catch(error => {
        console.error("Error fetching or parsing data:", error);
      });
  }
  function deleteStorage() {
    // delete autosave for tp when last modification was more than one month old
    let keys = Object.keys(localStorage);

    keys.forEach(key => {
      if (key.includes("_TP")) {
        const storedData = JSON.parse(localStorage.getItem(key));
        const date = new Date(storedData.date);
        const oneMonthAgo = new Date();
        const oneHourAgo = new Date();
        oneHourAgo.setHours(oneHourAgo.getHours() - 1);
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        if (date <= oneMonthAgo) {
          localStorage.removeItem(key);
        }
      }
    });
  }
  useLayoutEffect(() => {
    // console.log(localStorageSpace());
    deleteStorage();
  }, []);
  const {
    isMobile,
    split,
    showOverbite,
    showBolton,
    showMovement,
    showRecords,
    showStaging,
    showReject,
    showApprove,
    compareModifications,
    currentStep,
    setStepperControls,
    stepperControls,
    saving,
    saved,
    autoSaveDate,
    hasElastics,
    elastics,
    startRevision,
    setControls3D,
    show3DControls,
    showContModification,
    pontics,
    setLayout,
    occ,
    complementaryColor,
    backgroundColor,
    isExistingAttachments,
    is3DControlsLoaded,
    toggledRoot,
    setToggleGlobalStore,
    isTranslator,
  } = useGlobalStore(state => ({
    hasElastics: state.toggle.hasElastics,
    elastics: state.toggle.elastics,
    split: state.toggle.split,
    showMovement: state.toggle.showMovement,
    showRecords: state.toggle.showRecords,
    showStaging: state.toggle.showStaging,
    showOverbite: state.toggle.showOverbite,
    showReject: state.toggle.showReject,
    showApprove: state.toggle.showApprove,
    showBolton: state.toggle.showBolton,
    compareModifications: state.toggle.compareModifications,
    showContModification: state.toggle.showContModification,
    setToggleGlobalStore: state.setToggle,
    isMobile: state.layoutConfig.isMobile,
    currentStep: state.stepperControls.currentStep,
    setStepperControls: state.setStepperControls,
    stepperControls: state.stepperControls,
    saving: state.controls3D.saving,
    saved: state.controls3D.saved,
    autoSaveDate: state.controls3D.autoSaveDate,
    startRevision: state.toggle.startRevision,
    show3DControls: state.toggle.show3DControls,
    pontics: state.toggle.pontics,
    setLayout: state.setLayout,
    occ: state.toggle.occ,
    setControls3D: state.setControls3D,
    complementaryColor: state.layoutConfig.complementaryColor,
    backgroundColor: state.layoutConfig.backGroundColor,
    isExistingAttachments: state.controls3D.isExistingAttachments,
    is3DControlsLoaded: state.controls3D.is3DControlsLoaded,
    toggledRoot: state.toggle.toggledRoot,
    isTranslator: state.layoutConfig.isTranslator,
  }));

  const [view, setView] = useState("front");
  const [model, setModel] = useState(null);
  const [hasIPR, sethasIPR] = useState(false);
  const [toggleModifications, setToggleModifications] = useState(false);
  const [parsedMovementTables, setParsedMovementTables] = useState([]);

  const [response, setResponse] = useState("");
  const [issueType, setIssueType] = useState("");

  const handle = useFullScreenHandle();

  if (!isGlobalStoreToggleDefined) {
    setGlobalStoreToggleRef(setToggleGlobalStore);
  }

  useEffect(() => {
    if (localStorage.getItem("ViewerBackGroundColor")) {
      setLayout(
        "backGroundColor",
        localStorage.getItem("ViewerBackGroundColor"),
      );
    }
    if (!SingletonManager.isInitialized) {
      SingletonManager.initializeAll();
    }
  }, []);
  useWindowOrientation();
  // this utility function allows you to use any three.js

  async function loadDrcModels(drcFiles) {
    let dracoLoader = new DRACOLoader();
    // ../node_modules/three/examples/jsm/libs/draco/
    dracoLoader.setDecoderPath(`https://www.gstatic.com/draco/v1/decoders/`);
    dracoLoader.setDecoderConfig({ type: "wasm" });
    const startTime = Date.now();

    const loadingPromises = drcFiles.map(drcFile => {
      // Get the binary content of the file
      const buffer = drcFile["buffer"];
      // Return a new promise for the decoding process
      return new Promise(async (resolve, reject) => {
        dracoLoader.parse(
          buffer,
          // .decodeGeometry(buffer)
          geometry => {
            if (Number.isFinite(parseInt(drcFile.num))) {
              createRoot(geometry, drcFile.num);
            } else {
              createBone(geometry, drcFile.num);
            }
            // On success, create a mesh and resolve the promise

            resolve(mesh);
          },
        );
      });
      // Pass any decoding errors up
    });
    // Return a single promise that resolves when all individual models have loaded

    const result = await Promise.all(loadingPromises);
    console.log(result, "Relu Done");
    return result;
  }
  const loadGLTFDRC = async (url, cbctURL, rootURL) => {
    globalData.isCBCT = Boolean(cbctURL);
    globalData.isRoot = Boolean(rootURL);

    if (!isMobileBrowser() && (globalData.isCBCT || globalData.isRoot)) {
      await UnzipHelper.unzipFromUrl(
        globalData.isCBCT
          ? cbctURL
          : rootURL /* "CBCT-OK-DRCPRT-NP_outputs.zip" */,
      ).then(result => {
        if (result) {
          loadDrcModels(result);
        } else {
          console.log(
            `${globalData.isCBCT ? "root sim" : "cbct"} preparation has failed`,
          );
        }
        loadingCounter++;
        if (loadingCounter === 2) {
          setTpLoaded(true);
          setNotFound(false);
        }

        console.log("root process done");
      });
    } else {
      loadingCounter++;
      if (loadingCounter === 2) {
        setTpLoaded(true);
        setNotFound(false);
      }
    }
    console.log("first call");

    let startTime1 = Date.now();
    if (loadedOnce) {
      console.log("breaking");
      return;
    }
    loadedOnce = true;

    try {
      let dracoLoader = new DRACOLoader();
      // ../node_modules/three/examples/jsm/libs/draco/
      dracoLoader.setDecoderPath(`${process.env.PUBLIC_URL}/Draco/`);
      dracoLoader.setDecoderConfig({ type: "wasm" });
      const loader = new GLTFLoader();
      loader.setDRACOLoader(dracoLoader);

      const gltf = await new Promise((resolve, reject) => {
        loader.load(url, resolve, undefined, reject);
      });

      const gltfHolder = gltf.scene.children[0];
      const startTime = Date.now();

      if (!gltfHolder.children[2].userData.start_together) {
        fixOTPEndTogether(
          myOTP,
          gltfHolder.children[2].userData.upper_steps_number,
          gltfHolder.children[2].userData.lower_steps_number,
        );
      }
      // StartLoadingTime(startTime, data);

      setModel(gltfHolder);
      isBJ = gltfHolder.children[2].userData.bitejump;
      setIsBiteJumpActive(isBJ, false);
      if (isBJ) {
        setBJMatrices(gltfHolder.children[2].userData.bitejump_matrix);
      }
      globalBiteJump = gltfHolder.children[2].userData.bitejump;
      // MeshOrganiser(gltfHolder);

      GLBDataV2 = await startBaseMeshOrganising(gltfHolder);
      meshOrganiserFiller(gltfHolder, myOTP);
      if (!gltfHolder.children[2].userData.start_together) {
        fixGLBDataEndTogether(
          GLBData,
          gltfHolder.children[2].userData.upper_steps_number,
          gltfHolder.children[2].userData.lower_steps_number,
        );
      }

      const preparedBase = [
        ...gltfHolder.children[0].children[globalData.upperSteps + 1].children,
        ...gltfHolder.children[1].children[globalData.lowerSteps + 1].children,
      ];
      preparedBase.sort(TeethSort);
      assignBaseTeethGLB1(preparedBase);

      assignBaseAtt(gltfHolder?.children[3]);

      preparePonticsData(gltfHolder.children[2].userData.pontics);
      prepareIpr(gltfHolder, setIprOverlays);
      prepareIpr(gltfHolder, setIprOverlays);

      prepareNumbering();
      console.log("FOR DEMACIAAAAAA");

      prepareTeethAxes(myOTP);

      SetCutsAndButtonsElasticsData(gltfHolder.children[2].userData.elastics);
      idleManager = new IdleManager();

      teethTransformationData = prepareTeethORIandCenter(myOTP);
      const endTime = Date.now() - startTime;
      endLoadingTime(endTime, data, startTime);
      startSession();
      loadingCounter++;
      console.log("DONE Conv");

      if (loadingCounter === 2) {
        setTpLoaded(true);
        setNotFound(false);
      }
      // glbDataDisposer(); // no need

      globalMaxStepNumber = Math.max(
        gltfHolder.children[2].userData.upper_steps_number,
        gltfHolder.children[2].userData.lower_steps_number,
      );
      dracoLoader.dispose();
      dracoLoader = null;
      console.log("done this");
    } catch (error) {
      console.error("Error loading GLTF model:", error);
      throw error;
    }
  };

  // TODO: move data preperation to react query level modification (already cached too), and any other dependencies to custom hooks
  const [iprOverLays, setIprOverlays] = useState([]);
  const [numberingOverLays, setNumberingOverlays] = useState([]);
  const [stagingTimeline, setStagingTimeline] = useState({
    loading: true,
    data: null,
  });
  function prepareTeethAxes(otp) {
    const data = otp.Segmentation.Value.Teeth;
    for (let index = 0; index < data.length; index++) {
      const toothData = data[index];
      teethMovementData[toothData.Unn] = {
        ToothRotationCenter: new THREE.Vector3(
          ...toothData.ToothRotationCenter,
        ),
        ToothOrientation: {
          Up: new THREE.Vector3(...toothData.ToothOrientation.Up),
          Front: new THREE.Vector3(...toothData.ToothOrientation.Front),
          Side: new THREE.Vector3(...toothData.ToothOrientation.Side),
        },
      };
    }
  }
  function testMatrixTool(otp) {
    console.log("=".repeat(60));
    console.log("MATRIX TO CLINICAL MOVEMENTS CONVERTER TEST (Three.js)");
    console.log("=".repeat(60));
    const failedTests = [];
    const testCacher = [];
    const segmentationData = otp.Segmentation.Value.Teeth;
    for (let index = 0; index < segmentationData.length; index++) {
      const toothData = segmentationData[index];
      testCacher[toothData.Unn] = {
        ToothRotationCenter: toothData.ToothRotationCenter,
        ToothOrientation: toothData.ToothOrientation,
      };
    }
    const stagesData = otp.Stages;
    for (let stepIndex = 0; stepIndex < stagesData.length; stepIndex++) {
      teethMovementDataPerStep.push({});

      const teeth = stagesData[stepIndex].Teeth;
      for (let toothIndex = 0; toothIndex < teeth.length; toothIndex++) {
        const toothData = teeth[toothIndex];
        if (toothData.$type === "ExtractedTooth") {
          continue;
        }
        const result1 = runTest(
          toothData.Movement.Value.Transformation,
          testCacher[toothData.Unn].ToothOrientation,
          testCacher[toothData.Unn].ToothRotationCenter,
          toothData.Movement.Value.MovementValues.Value,
          toothData.Unn,
        );
        if (!result1.allPass) {
          failedTests.push({
            unn: toothData.Unn,
            step: stepIndex,
            ToothMatrix: toothData.Movement.Value.Transformation,
            ToothOrientation: testCacher[toothData.Unn].ToothOrientation,
            ToothRotationCenter: testCacher[toothData.Unn].ToothRotationCenter,
            MovementValues: toothData.Movement.Value.MovementValues.Value,
            result: result1.result,
          });
        }
        teethMovementDataPerStep[stepIndex][toothData.Unn] = {
          intrusionExtrusion:
            toothData.Movement.Value.MovementValues.Value.IntrusionExtrusion,
          mesialDistal: toothData.Movement.Value.MovementValues.Value.LeftRight,
          buccalLingual:
            toothData.Movement.Value.MovementValues.Value.ForwardBackward,
          rotation: toothData.Movement.Value.MovementValues.Value.Rotation,
          inclination:
            toothData.Movement.Value.MovementValues.Value.Inclination,
          angulation: toothData.Movement.Value.MovementValues.Value.Angulation,
        };
      }
    }
    if (failedTests.length !== 0) {
      console.error("Matrix Rebaser Failed");
    }
    console.log(`Matrix Rebaser Failed Tests => `, failedTests);
  }
  function fixOTPEndTogether(otp, upperSteps, lowerSteps) {
    globalDiff = upperSteps - lowerSteps;

    const isUpperGreaterThanLower = globalDiff > 0;
    if (isUpperGreaterThanLower) {
      for (
        let originalStepNum = lowerSteps, targetedStepNum = upperSteps;
        targetedStepNum > 0;
        targetedStepNum--, originalStepNum--
      ) {
        const originalStep = otp.Stages[originalStepNum];
        const targetedStep = otp.Stages[targetedStepNum];

        if (originalStepNum > 0) {
          copyOTPSteptoStep(
            originalStep,
            targetedStep,
            isUpperGreaterThanLower,
          );
        } else {
          copyOTPSteptoStep(
            otp.Stages[0],
            targetedStep,
            isUpperGreaterThanLower,
          );
        }
      }
    } else {
      for (
        let originalStepNum = upperSteps, targetedStepNum = lowerSteps;
        targetedStepNum > 0;
        targetedStepNum--, originalStepNum--
      ) {
        const originalStep = otp.Stages[originalStepNum];
        const targetedStep = otp.Stages[targetedStepNum];

        if (originalStepNum > 0) {
          copyOTPSteptoStep(
            originalStep,
            targetedStep,
            isUpperGreaterThanLower,
          );
        } else {
          copyOTPSteptoStep(
            otp.Stages[0],
            targetedStep,
            isUpperGreaterThanLower,
          );
        }
      }
    }
  }
  function fixGLBDataEndTogether(GLBData, upperSteps, lowerSteps) {
    const isUpperGreaterThanLower = globalDiff > 0;
    if (isUpperGreaterThanLower) {
      for (
        let originalStepNum = lowerSteps, targetedStepNum = upperSteps;
        targetedStepNum > 0;
        targetedStepNum--, originalStepNum--
      ) {
        const originalStep = GLBData[originalStepNum];
        const targetedStep = GLBData[targetedStepNum];

        if (originalStepNum > 0) {
          copyGumSteptoStep(
            originalStep,
            targetedStep,
            isUpperGreaterThanLower,
          );
        } else {
          copyGumSteptoStep(GLBData[0], targetedStep, isUpperGreaterThanLower);
        }
      }
    } else {
      for (
        let originalStepNum = upperSteps, targetedStepNum = lowerSteps;
        targetedStepNum > 0;
        targetedStepNum--, originalStepNum--
      ) {
        const originalStep = GLBData[originalStepNum];
        const targetedStep = GLBData[targetedStepNum];

        if (originalStepNum > 0) {
          copyGumSteptoStep(
            originalStep,
            targetedStep,
            isUpperGreaterThanLower,
          );
        } else {
          copyGumSteptoStep(GLBData[0], targetedStep, isUpperGreaterThanLower);
        }
      }
    }
  }

  function copyOTPSteptoStep(firstStep, secondStep, isUpperSwap) {
    const firstStepTeeth = firstStep.Teeth;
    const secondStepTeeth = secondStep.Teeth;

    for (
      let toothIndex = 0;
      toothIndex < firstStep.Teeth.length;
      toothIndex++
    ) {
      if (isToothOfJaw(firstStepTeeth[toothIndex].Unn, !isUpperSwap)) {
        if (firstStepTeeth[toothIndex].Movement) {
          secondStepTeeth[toothIndex].$type = firstStepTeeth[toothIndex].$type;
          secondStepTeeth[toothIndex].$type = firstStepTeeth[toothIndex].$type;
          if (!secondStepTeeth[toothIndex].Movement) {
            secondStepTeeth[toothIndex].Movement = {
              Value: { Transformation: {} },
            };
          }
          secondStepTeeth[toothIndex].Attachments =
            firstStepTeeth[toothIndex].Attachments;
          secondStepTeeth[toothIndex].Movement.Value.Transformation =
            firstStepTeeth[toothIndex].Movement.Value.Transformation.map(
              innerArray => [...innerArray],
            );
        }
      }
    }
  }

  function copyGumSteptoStep(firstStep, secondStep, isUpperSwap) {
    const jawName = isUpperSwap ? "lower" : "upper";
    secondStep[jawName].gum.geometry = firstStep[jawName].gum.geometry;
  }
  function isToothOfJaw(number, isUpperJaw) {
    return isUpperJaw ? number < 17 : number > 16;
  }

  function glbDataDisposer() {
    console.log("ending disposer");

    return;
    let object;
    for (let stepIndex = 0; stepIndex < GLBData.length; stepIndex++) {
      object = GLBData[stepIndex].lower.gum;
      disposeObject(object);
      object = GLBData[stepIndex].upper.gum;
      disposeObject(object);
      for (
        let toothIndex = 0;
        toothIndex < GLBData[stepIndex].lower.teeth.length;
        toothIndex++
      ) {
        disposeObject(GLBData[stepIndex].lower.teeth[toothIndex]);
      }
      for (
        let toothIndex = 0;
        toothIndex < GLBData[stepIndex].upper.teeth.length;
        toothIndex++
      ) {
        disposeObject(GLBData[stepIndex].upper.teeth[toothIndex]);
      }
    }
  }

  /**
   * gets the Orientation points and center from the OTP for each tooth
   */
  function prepareTeethORIandCenter(OTP) {
    return;
    if (!OTP.Segmentation) {
      console.log("old otp format");
      return;
    }
    let teethTransformationData = [];
    for (let i = 0; i < OTP.Segmentation.Value.Teeth.length; i++) {
      teethTransformationData[OTP.Segmentation.Value.Teeth[i].Unn - 1] = {
        ...OTP.Segmentation.Value.Teeth[i].ToothOrientation,
        ToothRotationCenter:
          OTP.Segmentation.Value.Teeth[i].ToothRotationCenter,
      };
    }
    return teethTransformationData;
  }

  function prepareFirstMovementValues() {
    let result = [];
    result.fill(0, 0, 31);
    let lastMovement = OTP.Stages[OTP.Stages.length - 1];
    for (let i = 0; i < lastMovement.Teeth.length; i++) {
      let movement = lastMovement.Teeth[i].Movement.Value.MovementValues.Value;
      result[lastMovement.Teeth[i].Unn] = {
        "Mesial/Distal": movement.LeftRight,
        "Buccal/Lingual": movement.ForwardBackward,
        "Extrusion/Intrusion": movement.IntrusionExtrusion,
        RightHinge: 0,
        LeftHinge: 0,
        Inclination: movement.Inclination,
        Angulation: movement.Angulation,
        Rotation: movement.Rotation,
      };
    }
    setControls3D("teethMovements", result);
  }

  useEffect(() => {
    isC && fetchData();
    // isC && fetchIssueType();
  }, []);

  useEffect(() => {
    if (show3DControls) {
      TurnElastics(false);
      setToggle("elastics", false);
    }
  }, [show3DControls]);
  useEffect(() => {
    TurnElastics(elastics);
  }, [elastics]);

  useEffect(() => {
    if (show3DControls) {
      setToggle("split", false);
      measurementTool.isSplit = false;
    }
  }, [show3DControls]);

  function prepareIpr(modal, setIprOverlays) {
    const globalDiff = 0;
    let model = modal;
    modal = modal.children[2].userData;
    let upperOrLower = 0;
    let splitHolder;
    const newArray = JSON.parse(JSON.stringify(iprOverLays)); //create deep copy of ipr array
    newArray[0] = {};
    newArray[1] = {};
    let maxUpper = -1;
    let maxLower = -1;
    let iprKeys = Object.keys(modal.teeth_info);
    iprKeys.forEach(key => {
      splitHolder = key.split("_");
      let step = parseInt(splitHolder[1].substring(2, 5));
      let teethNum = parseInt(splitHolder[2].substring(1, 4));
      if (splitHolder[0] === "u") {
        upperOrLower = 0;
        if (globalDiff < 0) {
          step = step - globalDiff;
        }
        if (maxUpper < step) {
          maxUpper = step;
        }
      } else {
        upperOrLower = 1;
        if (globalDiff > 0) {
          step = step + globalDiff;
        }
        if (maxLower < step) {
          maxLower = step;
        }
      }
      if (numberingOverLays[step] === undefined) {
        numberingOverLays[step] = [];
      }
      if (numberingOverLays[step][upperOrLower] === undefined) {
        numberingOverLays[step][upperOrLower] = [];
      }
      numberingOverLays[step][upperOrLower][teethNum] = {
        label_position_center: modal.teeth_info[key].label_position_center,
        label_position_end: modal.teeth_info[key].label_position_end,
      };
      // delete modal.teeth_info[key]["label_position_center"];
      // delete modal.teeth_info[key]["label_position_end"];
      if (newArray[upperOrLower][splitHolder[2]] == undefined) {
        newArray[upperOrLower][splitHolder[2]] = [];
      }
      modal.teeth_info[key]["step"] = step;
      newArray[upperOrLower][splitHolder[2]].push(modal.teeth_info[key]);
    });
    if (maxLower != -1 && maxUpper != -1) {
      if (modal.start_together) {
        if (maxLower != maxUpper) {
          if (maxLower > maxUpper) {
            for (let x = maxUpper + 1; x <= maxLower; x++) {
              numberingOverLays[x][0] = numberingOverLays[maxUpper][0];
            }
          } else {
            for (let x = maxLower + 1; x <= maxUpper; x++) {
              numberingOverLays[x][1] = numberingOverLays[maxLower][1];
            }
          }
        }
      } else {
        if (bad)
          if (globalDiff > 0) {
            for (let i = 0; i < globalDiff; i++) {
              numberingOverLays[i][1] = numberingOverLays[globalDiff][1];
              let teethKeys = Object.keys(newArray[1]);
              teethKeys.forEach(item => {
                let r = structuredClone(newArray[1][item][0]);
                newArray[1][item][0].amount = null;
                newArray[1][item].unshift(r);
              });
            }
          } else if (globalDiff < 0) {
            for (let i = 0; i < -globalDiff; i++) {
              numberingOverLays[i][0] = numberingOverLays[-globalDiff][0];
              let teethKeys = Object.keys(newArray[0]);
              teethKeys.forEach(item => {
                let r = structuredClone(newArray[0][item][0]);
                newArray[0][item][0].amount = null;
                newArray[0][item].unshift(r);
              });
            }
          }
      }
    }
    bad = true;
    let globalDiff1 = 0;
    if (model.children[0].children.length > model.children[1].children.length) {
      globalDiff1 =
        model.children[0].children.length - model.children[1].children.length;
    } else if (
      model.children[0].children.length < model.children[1].children.length
    ) {
      globalDiff1 =
        model.children[0].children.length - model.children[1].children.length;
    }
    if (globalDiff1 > 0) {
      let keys = Object.keys(newArray[1]);
      keys.forEach(item => {
        let lastIndex = newArray[1][item].length - 1;
        for (let i = 0; i < globalDiff1; i++) {
          let copy = structuredClone(newArray[1][item][lastIndex]);
          copy.amount = null;
          newArray[1][item].push(copy);
        }
      });
    } else if (globalDiff1 < 0) {
      let keys = Object.keys(newArray[0]);
      keys.forEach(item => {
        let lastIndex = newArray[0][item].length - 1;
        for (let i = 0; i > globalDiff1; i--) {
          let copy = structuredClone(newArray[0][item][lastIndex]);
          newArray[0][item].push(copy);
        }
      });
    }
    removePonticsIPRKey(newArray);

    setIprOverlays(newArray);
  }
  function removePonticsIPRKey(newArray) {
    for (let toothNumber = 1; toothNumber <= 32; toothNumber++) {
      if (ponticsData[toothNumber]) {
        delete newArray[toothNumber < 16 ? 0 : 1]["t".concat(toothNumber)];
      }
    }
  }
  function fixBiteJumpIPRKeys(model, newArray) {
    // console.log(numberingOverLays, iprOverLays);
    let indexOfLowestStepJaw =
      model.children[0].children.length < model.children[1].children.length
        ? 0
        : 1;
    let maxStepNumber;
    let lowestStepNumberJaw;
    if (model.children[0].children.length < model.children[1].children.length) {
      maxStepNumber = model.children[1].children.length;
      lowestStepNumberJaw = model.children[0].children.length;
    } else {
      maxStepNumber = model.children[0].children.length;
      lowestStepNumberJaw = model.children[1].children.length;
    }
    Object.values(newArray[indexOfLowestStepJaw]).forEach(ipr => {
      for (
        let step = lowestStepNumberJaw - 1;
        step < maxStepNumber - (indexOfLowestStepJaw === 0 ? 0 : 1);
        step++
      ) {
        if (!ipr[step]) {
          break;
        }
        ipr[step] = ipr[step - 1];
      }
    });
  }
  function fixBiteJumpNumberingKeys(model) {
    let newArray = numberingOverLays;
    let indexOfLowestStepJaw =
      model.children[0].children.length < model.children[1].children.length
        ? 0
        : 1;
    let maxStepNumber;
    let lowestStepNumberJaw;
    if (model.children[0].children.length < model.children[1].children.length) {
      maxStepNumber = model.children[1].children.length;
      lowestStepNumberJaw = model.children[0].children.length;
    } else {
      maxStepNumber = model.children[0].children.length;
      lowestStepNumberJaw = model.children[1].children.length;
    }
    for (let step = lowestStepNumberJaw - 1; step < maxStepNumber - 1; step++) {
      newArray[step + ""][indexOfLowestStepJaw] =
        newArray[(step - 1).toString()][indexOfLowestStepJaw];
    }
  }
  function prepareNumbering() {
    const numbersGeometry = [];
    let isLower;
    // let startTime = Date.now();
    const font = new FontLoader().parse(poppins);

    for (let stepNumber = 0; stepNumber < GLBData.length; stepNumber++) {
      let toothIndex = -1;
      for (let toothNumber = 1; toothNumber <= 32; toothNumber++) {
        let tempStep = stepNumber;
        if (toothNumber < 17) {
          tempStep = Math.min(stepNumber, globalData.upperSteps);
          isLower = 0;
        } else {
          tempStep = Math.min(stepNumber, globalData.lowerSteps);

          if (isLower === 0) {
            toothIndex = -1;
          }
          isLower = 1;
        }

        if (
          numberingOverLays?.[tempStep]?.[isLower]?.[toothNumber] &&
          GLBData[stepNumber][isLower === 0 ? "upper" : "lower"].teeth[
            toothIndex + 1
          ]
        ) {
          toothIndex++;
          const label = numberingOverLays[tempStep][isLower][toothNumber];
          // let font = new FontLoader().parse(poppins);

          const text = (
            numberingUniversal[toothNumber][dentalNotation] || ""
          ).toString();

          if (text && !numbersGeometry[text]) {
            numbersGeometry[text] = new TextGeometry(text, {
              font: font,
              size: 2,
              depth: 0.05, //replacement from deprecated
              curveSegments: 2,
              bevelEnabled: false, // Disable bevel
            });

            numbersGeometry[text].computeBoundingBox();
            numbersGeometry[text].center();
          }

          const textMesh = new THREE.Mesh(
            numbersGeometry[text],
            textMaterial,
            // new THREE.MeshPhongMaterial({ color: "black" }),
          );
          // const label_distance = 0.01;
          const labelpos = new THREE.Vector3(
            label.label_position_center?.[0] - label.label_position_end?.[0],
            label.label_position_center?.[1] - label.label_position_end?.[1],
            label.label_position_center?.[2] - label.label_position_end?.[2],
          ).multiplyScalar(1.1);

          textMesh.position.set(
            label.label_position_center?.[0] - labelpos.x,
            label.label_position_center?.[1] - labelpos.y,
            label.label_position_center?.[2] - labelpos.z,
          );
          // let y_rotation = Math.atan2(
          //   label.label_position_end?.[0],
          //   label.label_position_end?.[2],
          // );
          textMesh.lookAt(textMesh.position.clone().sub(labelpos));
          textMesh.visible = true;
          textMesh.name = "teethNum_" + stepNumber + "_" + toothNumber;

          GLBData[stepNumber][isLower === 0 ? "upper" : "lower"].teeth[
            toothIndex % 16
          ].children[1].attach(textMesh.clone());
        }
      }
    }
    // console.log("Numbering time", Date.now() - startTime);

    return;
  }

  useEffect(() => {
    const checkForIpr = overlays => {
      for (const iprs of Object.values(overlays || {})) {
        for (const ipr of iprs) {
          if (ipr?.amount !== null) {
            setToggle("ipr", true);
            toggleIPRs(true);
            setToggle("hasIPR", true);
            return;
          }
        }
      }
    };
    const newArray = JSON.parse(JSON.stringify(iprOverLays));
    checkForIpr(newArray[0]); // 0 is upper arch
    checkForIpr(newArray[1]); // 1 is lower arch
  }, [iprOverLays]);

  const [tpLoaded, setTpLoaded] = useState(false);
  const [tpNotFound, setNotFound] = useState(false);

  const [maxStepNumber, setMaxStepNumber] = useState(0);
  // TODO: remove states and move to react query
  const [boltonInfo, setBoltonInfo] = useState({});
  const [steps, setSteps] = useState([]);
  const [biteJumpsSteps, setBiteJumpsSteps] = useState([]);
  const [photosXrays, serPhotosXrays] = useState([]);
  const [overbiteOverjet, setOverbiteOverjet] = useState("");
  // user Guiding
  const [ipAddress, setIPAddress] = useState("");
  const order = [
    "right_buccal",
    "frontal",
    "left_buccal",
    "upper_occlusal",
    "lower_occlusal",
    "front_smiling",
    "front_pose",
    "profile",
    "panoramic",
    "cephalometric",
  ];
  const triggerUserGuiding = () => {
    // fetch("https://api.ipify.org?format=json")
    //   .then(response => response.json())
    //   .then(data => {
    //     setIPAddress(data.ip);
    //     window.userGuiding.identify(data.ip);
    //   })
    //   .catch(error => console.log(error));

    if (window.parent) {
      window.addEventListener("message", function (event) {
        const photos_xrays = event?.data?.photos_xrays || {};
        // Advanced Heatmap flag
        if (Object.keys(photos_xrays).length > 0) {
          // Create a new sorted object
          const sortedC = {};

          //Iterate over the order array to sort the object
          order.forEach(key => {
            if (photos_xrays.hasOwnProperty(key)) {
              sortedC[key] = photos_xrays[key];
            }
          });
          //console.log(sortedC);
          serPhotosXrays(sortedC);
        }
        if (event?.data?.sessionId) {
          localStorage.setItem("mixpanelSessionId", event?.data?.sessionId);
        }

        if (event?.data?.user_data && false) {
          window.userGuiding.identify(event.data.user_data.uuid);
          setSuperProps({
            clientID: event?.data?.user_data?.companyUuid || "",
            doctorID: event?.data?.user_data?.uuid || "",
          });
        }
      });
    }
  };
  useEffect(() => {
    if (Object.keys(photosXrays).length > 0) {
      setToggle("hasPhotosXrays", true);
    } else {
      setToggle("hasPhotosXrays", false);
    }
  }, [photosXrays]);
  useEffect(() => {
    if (!isLoading) {
      if (error) {
        console.log(error, "Treatment plan not found");
        setTpLoaded(false);
        setNotFound(true);
      } else {
        fetchHTML();

        triggerUserGuiding();

        const boltonData = data?.boltonAnalysisInfo;

        globalData.boltonAnalysisInfo = convertBoltonToNumeric(boltonData);
        boltonData &&
        !isEmpty(boltonData) &&
        (!isEmpty(boltonData?.toothWidthTable) ||
          !isEmpty(boltonData?.anteriorRatio) ||
          !isEmpty(boltonData?.overAllRatio) ||
          !isEmpty(boltonData?.upperArchLength) ||
          !isEmpty(boltonData?.lowerArchLength))
          ? setBoltonInfo(boltonData)
          : setBoltonInfo(null);

        if (data?.otpFileUrl) {
          setStagingTimeline({ loading: true, data: null });
          try {
            getJSON(data?.otpFileUrl, (status, response) => {
              myOTP = response;
              console.log(myOTP);

              if (false) {
                loadGLTFDRC(
                  "25068290TV.OMAR_3d92e.glb",
                  data.alignedStlCbctUrl,
                  data.alignedStlUrl,
                );
              } else {
                data?.convertedFilesUrl
                  ? data?.convertedFilesUrl !== undefined
                    ? loadGLTFDRC(
                        data?.convertedFilesUrl,
                        data.alignedStlCbctUrl,
                        data.alignedStlUrl,
                      )
                    : (setTpLoaded(false), setNotFound(true))
                  : data?.new_converted_files_urls?.[0] !== undefined
                    ? loadGLTFDRC(
                        data?.new_converted_files_urls?.[0],
                        data.alignedStlCbctUrl,
                        data.alignedStlUrl,
                      )
                    : (setTpLoaded(false), setNotFound(true));
              }
              setStagingTimeline({
                loading: false,
                data: mapStagingTimeline(response),
              });
            });
          } catch (e) {
            setStagingTimeline({ loading: false, data: null });
          }
        } else {
          setStagingTimeline({ loading: false, data: null });
        }
      }
    }
  }, [isLoading, error]);
  useEffect(() => {
    if (tpLoaded) {
      // prepareIpr(model.children[2].userData, setIprOverlays);
      // if (!once && maxStepNumber !== 0) {
      //   prepareNumbering();
      //   once = true;
      // }

      //console.log(model.children[2].userData.elastics, "elastics form the other side");
      if (model.children[2].userData.elastics) {
        setToggle("hasElastics", true);
        setToggle("elastics", true);
      } else {
        setToggle("hasElastics", false);
        setToggle("elastics", false);
        TurnElastics(false);
      }

      //prepareFirstMovementValues();
      //console.log(model.children[2].userData);
      setToggle(
        "hasPontics",
        model.children[2].userData.pontics ? true : false,
      );
      setToggle(
        "hasBiteJump",
        model.children[2].userData.bitejump ? true : false,
      );
      if (model.children[2].userData.bitejump_steps) {
        setBiteJumpsSteps([
          model.children[2].userData?.bitejump_steps[0]?.split("st")[1],
          model.children[2].userData?.bitejump_steps[1]?.split("st")[1],
        ]);
      }

      setMaxStepNumber(
        Math.max(
          model.children[2].userData.upper_steps_number,
          model.children[2].userData.lower_steps_number,
        ),
      );
      const OBOJData = model.children[2].userData.bite_type;
      const obData = OBOJData.overbite;
      const ojData = OBOJData.overjet;
      globalData.OBOJ = {
        overbite: {
          11: {
            initial: obData.initial.R1,
            final: obData.final.R1,
          },
          12: {
            initial: obData.initial.R2,
            final: obData.final.R2,
          },
          21: {
            initial: obData.initial.L1,
            final: obData.final.L1,
          },
          22: {
            initial: obData.initial.L2,
            final: obData.final.L2,
          },
        },
        overjet: {
          11: {
            initial: ojData.initial.R1,
            final: ojData.final.R1,
          },
          12: {
            initial: ojData.initial.R2,
            final: ojData.final.R2,
          },
          21: {
            initial: ojData.initial.L1,
            final: ojData.final.L1,
          },
          22: {
            initial: ojData.initial.L2,
            final: ojData.final.L2,
          },
        },
      };
      setOverbiteOverjet(model.children[2].userData.bite_type);
      handlingTeethPerStep(model);
      if (window.parent) {
        window.parent.postMessage(
          {
            isLoading: false,
            hasTsqcReportedIssues: data?.hasTsqcReportedIssues,
            tsqcReportId: data?.tsqcReportId,
          },
          "*",
        );
      }
    }
  }, [tpLoaded, model, maxStepNumber, hasElastics]);

  const handlingTeethPerStep = model => {
    const upperSteps = model.children[2].userData.upper_steps_number;
    const lowerSteps = model.children[2].userData.lower_steps_number;

    let steps;
    if (model.children[2].userData.start_together) {
      steps = Array.from({ length: maxStepNumber + 1 }, (v, i) => ({
        u: i <= upperSteps ? true : false,
        l: i <= lowerSteps ? true : false,
      }));
    } else if (!model.children[2].userData.start_together) {
      // debugger;
      steps = Array.from({ length: maxStepNumber + 1 }, (v, i) =>
        isNegative(globalDiff)
          ? {
              u: i <= Math.abs(globalDiff) ? false : true,
              l: i <= lowerSteps ? true : false,
            }
          : {
              u: i <= upperSteps ? true : false,
              l: i <= Math.abs(globalDiff) ? false : true,
            },
      );
    }
    setSteps(prev => steps);
  };

  useEffect(() => {
    //console.log("legacy 300-11", handle.node.current.offsetWidth);
    if (!handle.active) {
      setToggle("expand", false);
    } else if (!handle.active) {
      setToggle("expand", true);
    }
  }, [handle.active]);
  useEffect(() => {
    if (!isAdvancedHeatmaps && !isMobileBrowser() && !isAppleMobile()) {
      setIsOrbitControlsAuthorized(data?.isOrbitControlsEnabled);
      setIsAdvancedHeatmaps(data?.isViewerAdvancedHeatmapEnabled);
    }
  }, [data]);
  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);
    return () => {
      window.removeEventListener("message", receiveMessage, false);
    };
  }, []);

  function receiveMessage(event) {
    // Display the received message
    if (event.data.reviseTreatment) {
      setToggle("startRevision", event.data.reviseTreatment);
    }
  }

  const { dentalNotation } = getParams();

  const [canModify, setCanModify] = useState(false);

  const toggleModificationsCard = () => {
    setToggleModifications(!toggleModifications);

    window.parent.postMessage(
      { startTrigger: true },
      process.env.REACT_APP_TDMS_URL,
    );
    window.addEventListener("message", function (event) {
      const photos_xrays = event?.data?.photos_xrays || {};
      // console.log({ photos_xrays });
      if (Object.keys(photos_xrays).length > 0) {
        // Create a new sorted object
        const sortedC = {};

        //Iterate over the order array to sort the object
        order.forEach(key => {
          if (photos_xrays.hasOwnProperty(key)) {
            sortedC[key] = photos_xrays[key];
          }
        });
        //console.log(sortedC);
        serPhotosXrays(sortedC);
      }
      const designer =
        event?.data?.current_job?.type === "DESIGN" ||
        event?.data?.current_job?.type === "PENDING_CONVERSION" ||
        event?.data?.current_job?.assigneeType === "DESIGN_SUPERVISOR";

      const next_tp = event?.data?.next_tp || null;

      const modify =
        data.status === "REJECTED" &&
        (next_tp === null ||
          next_tp.status === "NEW" ||
          next_tp.status === "CONVERTED");

      const canModifyKey = next_tp === null ? modify : designer && modify;

      setCanModify(next_tp === null ? modify : designer && modify);
    });
  };
  useEffect(() => {
    if (tpLoaded && show3DControls) {
      turnPontics(false);
      setToggle("pontics", false);
    }
  }, [show3DControls, tpLoaded]);
  useEffect(() => {
    tpLoaded && turnPontics(pontics);
  }, [tpLoaded, pontics]);
  const ref = useRef();

  useEffect(() => {
    if (isExistingAttachments) {
      setTimeout(() => {
        setControls3D("isExistingAttachments", false);
      }, [5000]);
    }
  }, [isExistingAttachments]);
  const { content } = useCustomTranslation();

  const getContent = (group, key) => {
    return content(`other.${group}.${key}`);
  };
  return (
    <FullScreen handle={handle} className="relative">
      {saving && <Saving />}
      {tpLoaded && <GhostCursorComponent />}
      {saved && <ChangeSaved autoSaveDate={autoSaveDate} />}
      {tpLoaded && (
        <>
          <AttachmentsToaster isExistingAttachments={isExistingAttachments} />
          <ApproveTPModal />
          {/* {startRevision && <Beta />} */}
          {
            <TeethControls
              startRevision={startRevision}
              ref={ref}
              dentalNotation={dentalNotation}
              maxStepNumber={maxStepNumber}
              currentStep={stepperControls.currentStep}
              tpLoaded={tpLoaded}
              GLBData={GLBData}
              iprOverLays={iprOverLays}
              setIprOverlays={setIprOverlays}
              model={model}
              movementTable={data?.movementTable}
              parsedMovementTables={parsedMovementTables}
            />
          }
          {/* Doctor modifications */}
          {
            <DoctorModifications
              redoAllComparingMode={ref.current}
              reset={ref.current?.reset}
              toggleModificationsCard={toggleModificationsCard}
              toggleModifications={toggleModifications}
              tp_data={data}
              canModify={canModify}
            />
          }

          {data?.status === "REJECTED" && !tdms && !isPatient && (
            <RevisedTreatment />
          )}
          {/*end Doctor modification */}
          {isC &&
            response?.reportedIssues &&
            response?.reportedIssues.length === 0 && (
              <OverlayWrapper
                showOverlay={!showApprove}
                overlayKey="showApprove"
                minWidth={418}
                defaultHeight={150}
                lessHeight={150}
              >
                <Approve data={data} />
              </OverlayWrapper>
            )}

          {isC &&
            response?.reportIssues &&
            response?.reportIssues?.length > 0 && (
              <OverlayWrapper
                showOverlay={!showReject}
                overlayKey="showReject"
                minWidth={418}
                defaultHeight={"50vh"}
                rejectHightWrapper
              >
                <Reject reportedIssues={response?.reportIssues} data={data} />
              </OverlayWrapper>
            )}

          <OverlayWrapper
            showOverlay={showOverbite}
            overlayKey="showOverbite"
            minWidth={340}
            defaultHeight={410}
          >
            <OverbiteAnalysis overbiteOverjet={overbiteOverjet} />
          </OverlayWrapper>
          <OverlayWrapper
            showOverlay={showBolton}
            overlayKey="showBolton"
            minWidth={340}
            defaultHeight={620}
          >
            <BoltonAnalysis boltonInfo={boltonInfo} />
          </OverlayWrapper>
          <OverlayWrapper
            showOverlay={showStaging}
            overlayKey="showStaging"
            minWidth={510}
            defaultHeight={710}
          >
            <StagingTimeLine
              maxStepNumber={maxStepNumber}
              steps={steps}
              stagingTimeline={stagingTimeline}
            />
          </OverlayWrapper>

          {/* <OverlayWrapper
            showOverlay={showMovement}
            overlayKey="showMovement"
            minWidth={610}
            defaultHeight={1000}
          > */}

          {/* </OverlayWrapper> */}

          <OverlayWrapper
            showOverlay={showRecords}
            overlayKey="showRecords"
            minWidth={400}
            defaultHeight={1000}
          >
            <Records photosXrays={photosXrays} />
          </OverlayWrapper>
        </>
      )}
      {(!tpNotFound || is3DControlsLoaded) && (
        <Loader
          complementaryColor={complementaryColor}
          tpLoaded={tpLoaded}
          is3DControlsLoaded={is3DControlsLoaded}
          text={
            is3DControlsLoaded
              ? "loading_3D_controls"
              : "preparing_treatment_plan"
          }
        />
      )}
      {tpNotFound && (
        <ViewerNotFound
          tpNotFound={tpNotFound}
          complementaryColor={complementaryColor}
        />
      )}
      {tpLoaded && isTranslator && <Header />}

      <div
        style={{
          gridTemplateColumns: "1fr",
          backgroundColor: backgroundColor,
          display: "grid",
          gridTemplateRows: !tpLoaded
            ? "1fr"
            : isMobile
              ? "1fr 55px 60px"
              : split || compareModifications
                ? "60px 1fr"
                : "60px 1fr 55px",
        }}
      >
        {tpLoaded && (
          <Nav
            view={view}
            setView={setView}
            handle={handle}
            GLBData={GLBData}
            hasIPR={hasIPR}
            boltonInfo={boltonInfo}
            disableMovement={isEmpty(data?.movementTable)}
            disableStaging={!data?.otpFileUrl}
          />
        )}
        <ThreeJsViews
          redoAllComparingMode={ref.current}
          setAutoSave={ref.current}
          view={view}
          tpLoaded={tpLoaded}
          iprOverLays={iprOverLays}
          setIprOverlays={setIprOverlays}
          numberingOverLays={numberingOverLays}
          setTpLoaded={setTpLoaded}
          maxStepNumber={maxStepNumber}
          model={model}
          setModel={setModel}
          GLBData={GLBData}
          fakeAttachmentReplacer={fakeAttachmentReplacer}
          isViewerControlsEnabled={isViewerControlsEnabled}
          teethTransformationData={teethTransformationData}
          hasIPR={hasIPR}
          biteJumpsSteps={biteJumpsSteps}
          ponticsData={ponticsData}
        />
        {showMovement && (
          <MovementTable
            movementTable={data?.movementTable}
            parsedMovementTables={parsedMovementTables}
            maxStepNumber={maxStepNumber}
          />
        )}
        {tpLoaded && (
          <div
            className={
              split || compareModifications
                ? toggledRoot !== "GUM"
                  ? "splitted_footer_with_note"
                  : "splitted_footer"
                : toggledRoot !== "GUM"
                  ? "footer_with_grid"
                  : "footer_without_grid"
            }
          >
            {toggledRoot !== "GUM" && (
              <div className="beta_banner">
                <div>
                  {displayMode === "GUM" || displayMode === "ROOTS"
                    ? getContent("labels", "simulated_roots_beta_note")
                    : getContent("labels", "cbct_visualization_beta_note")}
                </div>
                <a href="https://forms.gle/7xcJdCopQdqT93HJA" target="_blank">
                  {getContent("labels", "share_your_feedback")}
                </a>
              </div>
            )}
            <div
              className={
                split || compareModifications
                  ? "bounty_footer_right"
                  : isMobile
                    ? "bounty_footer_landscape_mobile bounty_footer"
                    : "bounty_footer"
              }
              style={{
                color: complementaryColor,
                fontSize: isMobile ? "10px" : "14px",
                textAlign:
                  split || isMobile || compareModifications ? "center" : "left",
                bottom:
                  split || compareModifications
                    ? "20px"
                    : isMobile
                      ? "130px"
                      : "70px",
              }}
            >
              {getContent(
                "labels",
                "simulated_gingiva_and_tooth_movements_actual_clinical_results_may_vary",
              )}
            </div>
          </div>
        )}

        {showContModification && (
          <div
            className={
              split || compareModifications
                ? "bounty_footer_right"
                : isMobile
                  ? "bounty_footer_landscape_mobile bounty_footer"
                  : "bounty_footer"
            }
            style={{
              color: complementaryColor,
              fontSize: isMobile ? "10px" : "14px",
              textAlign:
                split || isMobile || compareModifications ? "center" : "left",
              top:
                split || compareModifications
                  ? "20px"
                  : isMobile
                    ? "130px"
                    : "120px",
            }}
          >
            {/* {getContent(
              "labels",
              "simulated_gingiva_and_tooth_movements_actual_clinical_results_may_vary",
            )} */}
            Initial Step
          </div>
        )}

        {tpLoaded && (split || compareModifications) && (
          <div className="splitted_footer_right">
            <div
              className="bounty_footer_left"
              style={{
                color: complementaryColor,
                fontSize: isMobile ? "10px" : "14px",
                textAlign:
                  split || isMobile || compareModifications ? "center" : "left",
                bottom:
                  split || compareModifications
                    ? "20px"
                    : isMobile
                      ? "130px"
                      : "70px",
              }}
            >
              {getContent(
                "labels",
                "simulated_gingiva_and_tooth_movements_actual_clinical_results_may_vary",
              )}
            </div>
          </div>
        )}
        {tpLoaded && !show3DControls && !toggleModifications && (
          <Stepper
            maxStepNumber={maxStepNumber}
            steps={steps}
            tpLoaded={tpLoaded}
            model={model}
          />
        )}
      </div>
    </FullScreen>
  );
}

export default Scene;
